import React, { useState } from 'react';
import { Modal, Box, SpaceBetween, Button, Icon } from '@cloudscape-design/components';

interface TaskStatusModalProps {
  visible: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
  status: 'complete' | 'in-progress';
}

const statusConfig = {
  'complete': {
    header: 'Change Status to Complete',
    icon: 'status-positive' as const,
    variant: 'success' as const,
    message: 'Are you sure you want to change the task status to Complete?',
  },
  'in-progress': {
    header: 'Change Status to In Progress',
    icon: 'status-in-progress' as const,
    variant: 'warning' as const,
    message: 'Are you sure you want to change the task status to In Progress?',
  },
};

export const TaskStatusModal: React.FC<TaskStatusModalProps> = ({
  visible,
  onDismiss,
  onConfirm,
  status,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const config = statusConfig[status];

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      onDismiss={onDismiss}
      visible={visible}
      header={config.header}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onDismiss}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleConfirm}
              disabled={isLoading}
              loading={isLoading}
            >
              Confirm
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween size="m">
        <SpaceBetween direction="horizontal" size="xs" alignItems="center">
          <Icon name={config.icon} size="normal" variant={config.variant} />
          <Box>{config.message}</Box>
        </SpaceBetween>
      </SpaceBetween>
    </Modal>
  );
};
